module.exports = __webpack_public_path__ + "static/media/trucos.8e38357f.svg";